export default {
    serverURL:   'https://comaygao.com',
    api:         'https://comaygao.com/graphql',
    // serverURL:   'http://localhost:8087',
    // api:         'http://localhost:8087/graphql',
    defaultLang: 'vn',
}
